import React, { HTMLAttributes } from 'react';
import LazyReactPlayer from 'react-player/lazy';
import { ReactPlayerProps } from 'react-player/types/lib';

import useClasses from '../../hooks/useClasses';

import './style.scss';

type Props = React.DetailedHTMLProps<
HTMLAttributes<HTMLDivElement>,
HTMLDivElement
> & {
  url: string;
};

/*
 * Wrapper around ReactPlayer to guard possible implementation
 * substitutions
 */

const Video: React.FC<Props> = ({ url, className, ...props }) => {
  const ReactPlayer = LazyReactPlayer as unknown as React.FC<ReactPlayerProps>;
  const { buildClass, joinClasses } = useClasses('Video');

  return (
    <div className={joinClasses(buildClass(), className)} {...props}>
      <ReactPlayer
        className={buildClass('inner')}
        url={url}
        width="100%"
        controls
      />
    </div>
  );
};

export default Video;
